/**
 * Narrow an unknown error to a Turnstile CAPTCHA_FAILED 403.
 * Backend shape: `{ error: { code: 'CAPTCHA_FAILED', message: string } }` with HTTP 403.
 */
export const isCaptchaFailedError = (err: unknown): boolean => {
  if (!err || typeof err !== 'object') return false
  const resp = (err as { response?: { status?: number; data?: { error?: { code?: string } } } }).response
  return resp?.status === 403 && resp?.data?.error?.code === 'CAPTCHA_FAILED'
}
